import { Fragment, h, JSX } from "@stencil/core";
import { Account } from "@phn/entities/content";
import { navStateStore } from "@phn/state/nav-state-store";
import { IsLoggedIn } from "@phn/utility/helper";

export default function Login({
  content,
  showSkeleton,
}: {
  content: Account;
  showSkeleton: boolean;
}): JSX.Element | null {
  const { login, more } = content;
  const { loggedInState } = navStateStore.state;
  const isLoggedIn = IsLoggedIn(loggedInState);

  if (isLoggedIn) {
    return null;
  }
  return (
    <div class="account-login">
      {showSkeleton ? (
        <Fragment>
          <div class="skeleton-login-container">
            <div class="skeleton-login" />
            <div class="skeleton-more" />
          </div>
        </Fragment>
      ) : null}
      <phn-nd-pcom-login
        login={login}
        more={more}
        style={{ display: showSkeleton ? "none" : "" }}
      />
    </div>
  );
}
